export const VERIFY_EMAIL_SUCCESS = "app/verifyEmail/VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAIL = "app/verifyEmail/VERIFY_EMAIL_FAIL";